import script from "./ChatPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ChatPanel.vue?vue&type=style&index=0&id=e922d5de&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e922d5de"]])

export default __exports__